import { t } from 'i18next';

/** Excel ballast choices and the CBR prefill used only on new projects or type changes. */
interface BallastDefinition {
    value: string;
    label: string;
    cbr: number | undefined;
}

const BALLAST_DEFINITIONS: readonly BallastDefinition[] = [
    { value: 'basalt', label: 'Basalt', cbr: 100 },
    { value: 'granite', label: 'Granite', cbr: 100 },
    { value: 'dolomite', label: 'Dolomite', cbr: undefined },
];

export const getBallastOptions = (): Array<{ value: string; label: string }> => BALLAST_DEFINITIONS.map(({ value, label }) => ({ value, label }));

export const getBallastCbr = (value: unknown): number | undefined => BALLAST_DEFINITIONS.find(item => item.value === value)?.cbr;

export const getBallastLabel = (value: string): string => BALLAST_DEFINITIONS.find(item => item.value === value)?.label ?? value;

export const getBallastTypeError = (value: unknown): string | undefined => (BALLAST_DEFINITIONS.some(item => item.value === value) ? undefined : String(t('unsupported_ballast_type')));
